import type { ReactNode } from 'react';

export const symbol_music_note_add: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M369.5-163.5Q326-207 326-270t43.5-106.5Q413-420 476-420q28 0 50.5 8t39.5 22v-420q0-12.75 8.63-21.38Q583.25-840 596-840h174q12.75 0 21.38 8.62Q800-822.75 800-810v75q0 12.75-8.62 21.37Q782.75-705 770-705H626v435q0 63-43.5 106.5T476-120q-63 0-106.5-43.5ZM290-650H190q-12.75 0-21.37-8.68-8.63-8.67-8.63-21.5 0-12.82 8.63-21.32 8.62-8.5 21.37-8.5h100v-100q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v100h100q12.75 0 21.38 8.68 8.62 8.67 8.62 21.5 0 12.82-8.62 21.32-8.63 8.5-21.38 8.5H350v100q0 12.75-8.68 21.37-8.67 8.63-21.5 8.63-12.82 0-21.32-8.63-8.5-8.62-8.5-21.37v-100Z"
		/>
	</svg>
);
